<div id="top-app-bar">
    <div class="top-app-bar-container">
        <div class="top-app-bar-logo-holder">
            <div
                id="top-app-bar-buttons"
                (click)="navigateToHome()"
                class="top-app-bar-buttons logo-button"
            >
                <button mat-icon-button>
                    <img alt="nCino Icon" src="src/assets/images/ncinoIcon.png" />
                </button>
            </div>
            <div *ngIf="isLBA && (isSuperUser || isPlatformUser || isDemoUser)">
                <span class="top-app-bar__title">
                    {{ clientFullName ? clientFullName : clientShortName }}
                </span>
            </div>
        </div>
        <div class="top-app-bar-control-button-group">
            <div class="top-app-bar-buttons-end">
                <div class="top-app-bar-buttons-end-items" style="margin-top: 5px">
                    <site-search class="nav-area-site-search"> </site-search>
                </div>
                <div
                    mat-icon-button
                    class="fa-layers top-app-bar-buttons-end-items"
                    style="margin-top: 14px"
                    (click)="openNotificationsDialog()"
                >
                    <mat-icon class="bell-icon-class" fontSet="fas" fontIcon="fa-bell"></mat-icon>
                    <span
                        class="fa-2x fa-layers-counter"
                        style="background-color: #e0000e"
                        *ngIf="unreadNotificationCount > 0"
                        >{{ unreadNotificationCount }}</span
                    >
                </div>
                <div
                    class="top-app-bar-buttons-end-items"
                    mat-button
                    [matMenuTriggerFor]="navBarMenu"
                >
                    <profile-picture
                        class="nav-avatar"
                        [size]="28"
                        [primaryIdentifier]="primaryIdentifier"
                        name="{{ userFullName }}"
                        [pictureChange]="pictureChange"
                    >
                    </profile-picture>
                </div>
                <mat-menu #navBarMenu="matMenu" yPosition="below">
                    <div class="profile-menu">
                        <ul class="mat-list">
                            <li class="mat-list-item" routerLink="/settings" tabindex="0">
                                <span class="mat-list-item__text">Profile</span>
                            </li>
                            <li class="mat-list-item" routerLink="/settings">
                                <span class="mat-list-item__text">Settings</span>
                            </li>
                            <li
                                *ngIf="(isSuperUser || isPlatformUser) && !isImpersonatingUser()"
                                class="mat-list-item"
                                (click)="openChangeClientDialog()"
                            >
                                <span class="mat-list-item__text">Change&nbsp;Client</span>
                            </li>
                            <li
                                *ngIf="canImpersonateUser()"
                                class="mat-list-item"
                                (click)="openChangeUserDialog()"
                            >
                                <span class="mat-list-item__text">View as User</span>
                            </li>
                            <li class="mat-list-item" routerLink="/login" (click)="logOut()">
                                <span class="mat-list-item__text">Log Out</span>
                            </li>
                        </ul>
                    </div>
                </mat-menu>
            </div>
        </div>
    </div>
</div>

<change-client-dialog
    (closed)="closeChangeClientDialog()"
    *ngIf="changeClientVisible"
></change-client-dialog>

<app-impersonate-dialog
    (closed)="closeChangeUserDialog()"
    *ngIf="changeUserVisible"
></app-impersonate-dialog>
